import { ArrowLeft, ArrowRight } from "components/icons/generated";
import Banner from "ds/components/Banner";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import FullScreenModalBody from "ds/components/FullScreenModal/Body";
import FullScreenModalFooter from "ds/components/FullScreenModal/Footer";
import Icon from "ds/components/Icon";
import { AnalyticsPageModule } from "hooks/useAnalytics/pages/module";
import useTypedContext from "hooks/useTypedContext";
import useURLParams from "hooks/useURLParams";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";
import useTypedFlags from "hooks/useTypedFlags";
import Card from "ds/components/Card";

import { availableSteps } from "../constants";
import { ModuleFormContext } from "../context";
import NewModuleIntermediateConfirmationStepTile from "./StepTile";
import { config, configNew } from "./constants";
import styles from "./styles.module.css";

const NewModuleIntermediateConfirmation = () => {
  const { sharingModulesBetweenSpaces } = useTypedFlags();
  const urlParams = useURLParams();
  const hasCopiedConfiguration = urlParams.size !== 0;

  const tileConfig = sharingModulesBetweenSpaces ? configNew : config;

  const { setIsIntermediateStepActive, currentStep, goToNextStep, goToSummary } =
    useTypedContext(ModuleFormContext);

  const onContinue = () => {
    setIsIntermediateStepActive(false);
    goToNextStep();
  };

  const onBack = () => {
    setIsIntermediateStepActive(false);
  };

  const onSkipToSummary = () => {
    setIsIntermediateStepActive(false);
    goToSummary();
  };

  const currentStepIndex = availableSteps.findIndex(
    (availableStep) => availableStep.step === currentStep
  );

  const availableActions = tileConfig.filter(({ action: { step } }) => {
    const actionStepIndex = availableSteps.findIndex(
      (availableStep) => availableStep.step === step
    );

    if (actionStepIndex > currentStepIndex) {
      return true;
    }

    return false;
  });

  return (
    <>
      <FullScreenModalBody>
        <FullScreenModalBodyHeader
          title="Module created"
          description="Now you can make it even more powerful by sharing it, attaching cloud, policies or contexts in the next steps!"
          noMargin
        />

        <Box direction="column" margin="x-large 0 large 0" gap="large">
          {hasCopiedConfiguration && (
            <Banner variant="warning" title="Configuration copied">
              Additional configuration was copied. You can go to summary to review it.
            </Banner>
          )}
          <Card
            variant="secondary"
            titleTag="h3"
            title="Choose shortcut or continue"
            contentGap="large"
          >
            {availableActions.map((action, i) => (
              <NewModuleIntermediateConfirmationStepTile
                hasCopiedConfiguration={hasCopiedConfiguration}
                key={i}
                {...action}
              />
            ))}
          </Card>
        </Box>
      </FullScreenModalBody>
      <FullScreenModalFooter className={styles.footerWrapper} justify="end">
        <Box gap="medium" justify="end">
          <Button
            analyticsTitle="Skip to summary click"
            analyticsProps={{
              location: "Intermediate step",
            }}
            variant="secondary"
            onPress={onSkipToSummary}
          >
            Skip to summary
          </Button>
          <Button
            variant="secondary"
            onPress={onBack}
            startIcon={({ className }) => <Icon src={ArrowLeft} className={className} />}
          >
            Back
          </Button>
          <Button
            variant="primary"
            analyticsTitle="Continue click on intermediate step"
            analyticsPage={AnalyticsPageModule.ModuleNew}
            onPress={onContinue}
            endIcon={({ className }) => <Icon src={ArrowRight} className={className} />}
          >
            Continue
          </Button>
        </Box>
      </FullScreenModalFooter>
    </>
  );
};

export default NewModuleIntermediateConfirmation;
